import axios from 'axios';
import { API_BASE_URL } from '../../../services/api';

const BASE_URL = `${API_BASE_URL}/api/ordering/quotation-prep`;

// Setup axios instance with token
const getAuthHeaders = () => {
  const token = localStorage.getItem('blum_token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

export const orderingQuotationService = {
  saveQuotation: async (quotationData) => {
    try {
      const isFormData = quotationData instanceof FormData;
      const headers = getAuthHeaders().headers;
      if (isFormData) {
        delete headers['Content-Type']; // Let browser set boundary
      }
      const response = await axios.post(BASE_URL, quotationData, { headers });
      return response.data;
    } catch (error) {
      console.error('Error saving ordering quotation:', error);
      throw error;
    }
  },

  updateStatus: async (id, status, note = '') => {
    try {
      const response = await axios.patch(`${BASE_URL}/${id}/status`, { status, note }, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error('Error updating quotation status:', error);
      throw error;
    }
  },

  updateOrderStatus: async (id, orderStatus, note = '') => {
    try {
      const response = await axios.patch(`${BASE_URL}/${id}/order-status`, { orderStatus, note }, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error('Error updating order lifecycle status:', error);
      throw error;
    }
  },

  getQuotations: async (params = {}) => {
    try {
      const auth = getAuthHeaders();
      const response = await axios.get(BASE_URL, { ...auth, params });
      return response.data;
    } catch (error) {
      console.error('Error fetching ordering quotations:', error);
      throw error;
    }
  },

  getQuotationById: async (id) => {
    try {
      const response = await axios.get(`${BASE_URL}/${id}`, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error(`Error fetching ordering quotation ${id}:`, error);
      throw error;
    }
  },

  getNextQuotationNo: async (category = 'Appliances') => {
    try {
      const response = await axios.get(`${BASE_URL}/next-no`, {
        ...getAuthHeaders(),
        params: { category }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching next ordering quotation number:', error);
      throw error;
    }
  }
};
